var t={textWeight:"Normal",h1:{textSize:"XXXXL"},h2:{textSize:"XXXL"},h3:{textSize:"XXL"},h4:{textSize:"XL"},h5:{textSize:"L"},h6:{textSize:"M"}};export{t as default};
